import axios from 'axios';

// Create an Axios instance for public routes that don't require authentication
const publicAxiosService = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

publicAxiosService.interceptors.response.use(
  res => {
    return Promise.resolve(res);
  },
  error => {
    return Promise.reject({
      ...error,
      status: error.response?.status || '',
      statusText: error.response?.statusText || '',
      message: error.response?.data?.detail || '',
    });
  }
);

export default publicAxiosService;
